import { DO_NOT_USE_FaWrapper } from '../../../v2/foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { useCalendar } from '../../Context.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '../../../v2/navigation/buttons/Button/Button.js';
import { Typography } from '../../../v2/foundation/Typography/styled.js';

function YearPickerToggleButton() {
  var _jsx2, _jsx3;
  var _useCalendar = useCalendar(),
    locale = _useCalendar.locale,
    timeZone = _useCalendar.timeZone,
    yearPickerVisible = _useCalendar.yearPickerVisible,
    toggleYearPicker = _useCalendar.toggleYearPicker,
    focusedDate = _useCalendar.focusedDate;
  var yearFormat = new window.Intl.DateTimeFormat(locale, {
    year: 'numeric',
    timeZone: timeZone
  });
  var month = new window.Intl.DateTimeFormat(locale, {
    month: 'long',
    timeZone: timeZone
  });
  return /*#__PURE__*/jsxs(Button, {
    appearance: "ghost",
    type: "button",
    onClick: toggleYearPicker,
    size: "small",
    children: [/*#__PURE__*/jsxs(Typography, {
      $fontWeight: "bold",
      children: [month.format(focusedDate), "\xA0", yearFormat.format(focusedDate)]
    }), yearPickerVisible ? /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
      icon: "chevron-up"
    }, _jsx2["icon"] = faChevronUp, _jsx2)) : /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx3 = {
      icon: "chevron-down"
    }, _jsx3["icon"] = faChevronDown, _jsx3))]
  });
}

export { YearPickerToggleButton };
